module.exports = __webpack_public_path__ + "img/logo_transparent.078d86ff.png";